import { createFileRoute } from "@tanstack/react-router";

import { specificationSummaryQueryOptions } from "@/hooks/specifications";
import { requireSpecsAccess } from "@/lib/route-guards";
import { legacySpecLandingPath, parseRouteId, redirectOffTree } from "@/lib/route-paths";

// `/specifications/id/:specId` — the donor's `SpecificationLatestRedirect`
// (`routes/specification-latest-redirect.tsx`), which BuildPro e-mails and the
// restricted Share link carry. It lands on the spec's newest published version
// by publish date, archived included, else its newest created — the summary's
// `legacyLandingVersionId`, which the server derives — replacing the history
// entry so Back does not return to the resolver.
//
// **A dead id, a spec with no versions, or a failed read land on the base
// list** (#678 Q9, a named break for the dead id: the donor sends a dead id to
// `/specifications`, the base list, only on an error, and otherwise nowhere).
// It renders nothing of its own: the router's pending fallback shows while the
// read runs, and no band (the donor's app bar mounts its header island here,
// a loading artefact recorded on #694 for the owner).

export const Route = createFileRoute("/_authed/_chrome/specifications/id/$specId")({
  beforeLoad: ({ context }) => {
    requireSpecsAccess(context.currentUser);
  },
  loader: async ({ context, params }) => {
    const specId = parseRouteId(params.specId);
    const summary =
      specId === null
        ? null
        : await context.queryClient
            .ensureQueryData(specificationSummaryQueryOptions(specId))
            .catch(() => null);
    redirectOffTree(legacySpecLandingPath(summary));
  },
});
